'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Service de configuration pour les onglets de la fiche produit.
 */
ngModule.factory("fpConfigurator", function ($q) {
  var tabRegistry = {};
  var providerRegistry = {};
  var tabById = function tabById(tabId) {
    return tabRegistry[tabId];
  };
  return {
    registerTab: function registerTab(tabId, tabDefinition) {
      tabRegistry[tabId] = tabDefinition;
    },
    setProductTabListProvider: function setProductTabListProvider(nature, providerFn) {
      providerRegistry[nature] = providerFn;
    },
    getFicheTabs: function getFicheTabs(produit) {
      var providerFn = providerRegistry[produit.natureRacine];
      if (providerFn == null) {
        providerFn = providerRegistry[produit.nature];
      }
      if (providerFn == null) {
        console.error('pas de provider pour la nature ' + produit.nature, produit);
        throw new Error('pas de provider pour la nature ' + produit.nature);
      }
      return $q.when(providerFn(produit)).then(function (tabIds) {
        return _.map(tabIds, tabById);
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/fiche-produit/fpConfigurator.js
// module id = 2782
// module chunks = 13